import VerticalStepper from '../../../../../../components/VerticalStepper/VerticalStepper';
import { transformOrderHistoryToStepperSteps } from '../utils/orderHistoryStepper.utils';
import { IOrderHistory } from '../../../../../../types/suscription/history.types';
import { ORDER_STATUS } from '../../../../../../types/orders';

interface IOrderHistoryStepperProps {
  orderHistory: IOrderHistory[];
  orderStatusName: ORDER_STATUS;
}

export const OrderHistoryStepper = ({ orderHistory, orderStatusName }: IOrderHistoryStepperProps) => {
  const steps = transformOrderHistoryToStepperSteps(orderHistory, orderStatusName);

  return <VerticalStepper steps={steps} />;
};
